import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
  private storage = localStorage;

  constructor() {}

  public get(name): string {
    return this.storage.getItem(name);
  }

  public set(name: string, value: any): void {
    //console.log(name, value);
    if (value === null || value === undefined) {
      this.storage.removeItem(name);
    } else if (typeof(value) === 'boolean') {
      if (value) {
        this.storage.setItem(name, 'true');
      } else {
        this.storage.setItem(name, 'false');
      }
    } else {
      this.storage.setItem(name, value);
    }
  }

  public reloadStorage(): void {}
}



// WEBPACK FOOTER //
// ./src/providers/storage.ts